import {
    GET_GAME_REQUEST,
    GET_GAME_SUCCESS,
    GET_GAME_FAILURE,
    GET_HOTS_REQUEST,
    GET_HOTS_SUCCESS,
    GET_HOTS_FAILURE,
    GET_CHALLENGE_REQUEST,
    GET_CHALLENGE_SUCCESS,
    GET_CHALLENGE_FAILURE,
} from '../constant/actionTypes';

export const getGame = payload => ({
    type: GET_GAME_REQUEST,
    payload,
});

export const getGameSuccess = payload => ({
    type: GET_GAME_SUCCESS,
    payload,
});

export const getGameFailure = payload => ({
    type: GET_GAME_FAILURE,
    payload,
});

export const getHots = payload => ({
    type: GET_HOTS_REQUEST,
    payload,
})

export const getHotsSuccess = payload => ({
    type: GET_HOTS_SUCCESS,
    payload,
})

export const getHotsFailure = payload => ({
    type: GET_HOTS_FAILURE,
    payload,
})

export const getChallenge = payload => ({
    type: GET_CHALLENGE_REQUEST,
    payload,
})

export const getChallengeSuccess = payload => ({
    type: GET_CHALLENGE_SUCCESS,
    payload,
})

export const getChallengeFailure = payload => ({
    type: GET_CHALLENGE_FAILURE,
    payload,
})